// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.toolbar[data-v-b162fc96]{\n    border-radius: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
